import { RouteRecordRaw } from 'vue-router'

import Authenticate from '@/popup/components/views/Authenticate/Authenticate.vue'
import Home from '@/popup/components/views/Home/Home.vue'
import RequestAccounts from '@/popup/components/views/Approvals/SelectAccount/RequestAccounts.vue'
import RelayerAccounts from '@/popup/components/views/Approvals/SelectAccount/RelayerAccounts.vue'
import SwitchNetwork from '@/popup/components/views/Approvals/SwitchNetwork/SwitchNetwork.vue'
import Sign from '@/popup/components/views/Approvals/Sign/Sign.vue'
import Confirmation from '@/popup/components/views/Approvals/Confirmation/Confirmation.vue'

const entryRoutes: Array<RouteRecordRaw> = [
  {
    path: '/auth',
    name: 'authenticate',
    component: process.env.EMBEDDED_WALLET ? Home : Authenticate,
  },
  {
    path: '/web3-auth/:id',
    name: 'requestAccounts',
    component: RequestAccounts,
  },
  {
    path: '/network-switch/:switchId',
    name: 'networkSwitch',
    component: SwitchNetwork,
  },
  {
    path: '/relayer-auth/:id',
    name: 'relayerAccounts',
    component: RelayerAccounts,
  },
  { path: '/sign/:id', name: 'sign', component: Sign },
  { path: '/transaction/:id', name: 'confirmation', component: Confirmation },
]

export default entryRoutes
